import React, { useState, useEffect } from "react";
import { Form, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { login, getUserDetails } from "../actions/userActions";
import FormContainer from "../components/FormContainer";
import LoaderButton from "../components/LoaderButton";

const LoginScreen = ({ location, history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const redirect = location.search?.split("=")[1] || "/billing";
  const dispatch = useDispatch();
  const { loading, error, userInfo } = useSelector((state) => state.userLogin);

  useEffect(() => {
    if (userInfo) {
      dispatch(getUserDetails());
      history.push(redirect);
    }
  }, [dispatch, history, userInfo, redirect]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  return (
    <div className="login-bg-img" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--bg-gradient-start) 0%, var(--bg-gradient-end) 100%)', zIndex: 1100 }}>
      <FormContainer>
        <Card className="p-4 custom-card-boxshadow border-0" style={{ maxWidth: '420px', margin: '0 auto', background: 'var(--card-bg)' }}>
          <Card.Title className="text-center mb-1 mt-2">
            <h3 style={{ fontWeight: 700, color: 'var(--primary-color)', letterSpacing: '-0.5px' }}>Ji-Billing</h3>
            <p className="text-muted" style={{ fontSize: '0.9rem', fontWeight: 500 }}>Sign in to your account</p>
          </Card.Title>
          {error && (
            <span style={{ color: "red" }} className="ml-4">
              {error}
            </span>
          )}
          <Card.Body>
            <Form onSubmit={submitHandler}>
              <Form.Group controlId="email">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                />
              </Form.Group>
              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </Form.Group>
              <LoaderButton isLoading={loading} type="submit" variant="primary" block className="mt-4" style={{ fontSize: '1.05rem', letterSpacing: '0.5px' }}>
                Sign In &rarr;
              </LoaderButton>
            </Form>
          </Card.Body>
        </Card>
      </FormContainer>
    </div>
  );
};

export default LoginScreen;
